import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "size", "disabled"];
import { getStyledAIIconButton } from './styledButtons/StyledAIBaseIconButton';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export function AIBaseIconButton(_ref) {
  let {
      children,
      size = 'medium',
      disabled
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const AIButtonComponent = getStyledAIIconButton(uiButtonProps.use);
  return /*#__PURE__*/_jsx(AIButtonComponent, Object.assign({}, uiButtonProps, {
    use: disabled ? '' : 'transparent',
    iconClassName: "ai-icon",
    size: size,
    disabled: disabled,
    children: children || /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
  }));
}